var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoDescargarReporte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99967 4H8.05967C8.65301 4 8.94634 4.72 8.52634 5.14L5.46634 8.2C5.20634 8.46 4.78634 8.46 4.52634 8.2L1.46634 5.14C1.04634 4.72 1.34634 4 1.93967 4H2.99967V0.666667C2.99967 0.3 3.29967 0 3.66634 0H6.33301C6.69967 0 6.99967 0.3 6.99967 0.666667V4ZM0.999674 11.3333C0.633008 11.3333 0.333008 11.0333 0.333008 10.6667C0.333008 10.3 0.633008 10 0.999674 10H8.99967C9.36634 10 9.66634 10.3 9.66634 10.6667C9.66634 11.0333 9.36634 11.3333 8.99967 11.3333H0.999674Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDescargarReporte);
export default __webpack_public_path__ + "static/media/icono_descargar_reporte.97dd90a055fee85a8bffb937935812c5.svg";
export { ForwardRef as ReactComponent };